import styled from "styled-components";

import variables from "../../../styles/variables";
import { Title } from "../../sections/Products/ProductList/styles";

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto 1fr auto;
  grid-template-areas:
    "msa msa"
    "filter filter"
    "phones phones"
    "legal legal";

  width: 100%;
  max-width: ${variables.defaultWidth}px;
  align-items: start;
  padding: 0 ${variables.layoutPadding}rem;
  margin: 0 auto;
  /* Legal details style override */
  section {
    grid-area: legal;
    margin-top: 0;
    margin-bottom: 40px;
    margin-top: 40px;
    padding-left: 0;
    & > div {
      padding-left: 0;
    }
  }
  @media screen and (max-width: 1023px) {
    padding: 0 ${variables.mobileLayoutPadding}rem;
  }
  @media screen and (max-width: 767px) {
    grid-template-columns: 100%;
    grid-template-areas:
      "msa"
      "filterButton"
      "filter"
      "phones"
      "legal";
  }
`;

export const PhoneColumnWrapper = styled.div`
  margin: 0 auto;
  width: 100%;
  justify-content: center;
  grid-area: phones;
  @media screen and (max-width: 767px) {
    width: 100%;
    padding-left: 0;
  }

  ${Title} {
    margin-top: 36px;
  }
`;

export const PhobioMsaContainer = styled.div<{$active: boolean;}>`
  display: grid;
  grid-template-columns: ${({ $active }) => ($active ? "1fr" : "1fr 1fr")};
  grid-area: msa;
  gap: 20px;
  padding-top: 0px;

  @media screen and (max-width: 1150px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
  }
`;

export const SmartFilters = styled.div`
  display: grid;
  grid-area: filter;
  margin: 0 auto;
  width: 100%;

  .btn-allFilters {
    display: none;
  }

  .functionalTextLink {
    &:disabled {
      color: ${variables.colorBlack};
      cursor: not-allowed;
    }
  }

  @media screen and (max-width: 767px) {

    .btn-allFilters {
      display: flex;
      width: 100%;
      justify-content: center;
    }

    .btn-standard-carrier,
    .btn-standard-brand,
    .btn-standard-offers {
      display: none;
    }
  }
`;

export const PhobioContainer = styled.div`
  width: 100%;
  height: 100%;
  display: ${({ hide }: { hide: boolean }) => (hide ? "none" : "block")};

  &:first-child {
    @media screen and (max-width: 1150px) {
      margin-bottom: 0px;
    }
  }
`;

export const PageWrapper = styled.div`
  background: ${variables.colorGreyLight};
  width: 100%;
  margin: 0 auto;
  padding: 16px 0 0;
`;

export const Wrapper = styled.div`
  width: 100%;
  margin: 0 auto 20px;
`;

export const BannerContainer = styled.div`
  width: 100%;
  max-width: ${variables.defaultWidth}px;
  padding: 0 ${variables.layoutPadding}rem;
  margin: 0 auto;

  @media screen and (max-width: 1023px) {
    padding: 0 ${variables.mobileLayoutPadding}rem;
  }
`;

export const FiltersContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-top: 36px;
  gap: 24px;
`;

export const MobileContainer = styled.div`
  display: flex;
  justify-content: center;
  @media screen and (max-width: 767px) {
    flex-direction: column;
    gap: 16px;
    width: 100%;
    align-items: center;
  }
`;

export const FilterWrapper = styled.div`
  width: 100%;
`;
